module.exports = __webpack_public_path__ + "static/media/Proveedores.82fdea55.png";